<kendo-datetimepicker
  scrollPicker
  (focusin)="focus()"
  (focusout)="blur()"
  [formControl]="$any(_control)"
  [format]="format()"
  placeholder=""
  [min]="min()"
  [max]="max()"
  [steps]="steps()"
  [popupSettings]="{
    appendTo: 'component',
  }"
>
  <kendo-datetimepicker-messages
    accept="{{ translation.leftMenu.accept | transloco }}"
    cancel="{{ translation.leftMenu.cancel | transloco }}"
    dateTab="{{ translation.leftMenu.date | transloco }}"
    today="{{ translation.leftMenu.today | transloco }}"
    timeTab="{{ translation.leftMenu.time | transloco }}"
  />
</kendo-datetimepicker>
